/**
 * ImpersonationBridge — handles BOTH new-tab and same-tab impersonation
 * flows. Writes the impersonation JWT to localStorage before the SPA hydrates
 * AuthContext from it (avoids the race condition the previous window.open +
 * addEventListener approach had).
 *
 * URL query params:
 *   token       — impersonation JWT issued by /master/tenants/{id}/impersonate
 *   dest        — final destination, default /agency-dashboard
 *   backup      — "1" if we should stash the CURRENT (pre-replace) token in
 *                 sessionStorage under "alp.master_token_backup" so the
 *                 ImpersonationBanner can offer a 1-click restore.
 */
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

const TOKEN_KEYS = ["alp.access_token", "alp.token"];
const BACKUP_KEY = "alp.master_token_backup";

export default function ImpersonationBridge() {
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const token = sp.get("token");
    const dest = sp.get("dest") || "/agency-dashboard";
    const backup = sp.get("backup") === "1";
    if (!token) {
      window.location.replace("/login");
      return;
    }
    try {
      if (backup) {
        // Stash whatever master token is currently live so we can restore
        // it with a single click from the impersonation banner.
        const current = localStorage.getItem(TOKEN_KEYS[0]) || localStorage.getItem(TOKEN_KEYS[1]);
        if (current) sessionStorage.setItem(BACKUP_KEY, current);
      }
      // Mirror to both keys to be tolerant across older builds that read
      // either name.
      TOKEN_KEYS.forEach(k => localStorage.setItem(k, token));
    } catch { /* private mode etc. */ }
    window.location.replace(dest);
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--al-bg)] text-[var(--al-text)]"
         data-testid="impersonation-bridge">
      <div className="inline-flex items-center gap-2 text-[13px] text-[var(--al-text-muted)]">
        <Loader2 className="w-4 h-4 animate-spin" /> Abrindo sessão da persona…
      </div>
    </div>
  );
}
